export default __webpack_public_path__ + "static/media/dahua.2f7b4f30.png";